var _style, _g, _path, _path2, _path3, _path4, _rect, _circle, _circle2, _g2, _circle3, _circle4, _g3, _path5, _line, _line2, _line3, _line4, _polyline, _line5, _line6, _polyline2, _line7, _line8, _line9, _line10, _path6, _path7, _line11, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVan(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.4 93.8",
    style: {
      enableBackground: "new 0 0 212.4 93.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;stroke:#164963;stroke-width:1.5;stroke-miterlimit:10;}\r\n\t.st1{fill:#EAEFF9;}\r\n\t.st2{fill:#90AED5;stroke:#0F324F;stroke-width:1.5;stroke-miterlimit:10;}\r\n\t.st3{fill:#FFFFFF;}\r\n\t.st4{fill:none;stroke:#0F324F;stroke-width:1.5;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st5{fill:#EAEFF9;stroke:#164963;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;}\r\n\t.st6{fill:none;stroke:#0F324F;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;}\r\n\t.st7{fill:none;stroke:#0F324F;stroke-width:1.5;stroke-miterlimit:10;}\r\n\t.st8{fill:#FFFFFF;stroke:#164963;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;}\r\n\t.st9{fill:none;stroke:#164963;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;}\r\n\t.st10{fill:#CCD9ED;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M161.7,83.7H65.2c-1.9,0-3.6-1.4-3.8-3.3c-0.3-2.4-1-4.2-1.5-5.4c-2.3-5.7-7.8-9.7-14.3-9.7s-12.1,4-14.3,9.7 c-0.5,1.2-1,3.1-1.3,5.4c-0.2,1.9-1.9,3.3-3.8,3.3l0,0c-0.2,0-0.5,0-0.8-0.1L3.9,79.4c-1.8-0.4-3.1-1.9-3.1-3.8v-30 c0-0.2,0-0.4,0.1-0.7L7.9,4c0.3-1.9,1.9-3.2,3.8-3.2h117.2c3.8,0,7.6,1,10.9,2.9l0,0c7.9,4.6,15.1,10.3,21.2,17l15.4,16.6 c2.2,2.3,4.8,4.2,7.7,5.5L207,53c1.1,0.5,2,1.6,2.2,2.8l2.4,12.4c0.1,0.2,0.1,0.5,0.1,0.7v9.3c0,1.9-1.4,3.6-3.4,3.8l-7.8,1 c-1.6,0.2-2.9-0.9-3.1-2.5c-0.3-2.3-0.9-4.3-1.4-5.6c-2.3-5.7-7.8-9.7-14.3-9.7s-12.1,4-14.3,9.7c-0.5,1.3-1.3,3.1-1.9,5.8 C165,82.5,163.5,83.7,161.7,83.7L161.7,83.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M196,75h15.7v-6.4l-0.3-1.8h-22.9C192.1,69,194.9,71.6,196,75L196,75z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M38.8,66.9h-38V75h30.5C32.8,71.2,35.3,68.5,38.8,66.9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M174.9,66.9H52.4c3.4,1.6,6,4.2,7.5,8.2h107.4C169,71.2,171.4,68.3,174.9,66.9z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14.6,
    y: 19.8,
    className: "st1",
    width: 112.6,
    height: 26.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 181.7,
    cy: 80.7,
    r: 12.4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 181.7,
    cy: 80.7,
    r: 7.8
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M177.3,83c0.8,1.6,2.5,2.6,4.4,2.6s3.5-1.1,4.4-2.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M186,78.4c-0.8-1.6-2.5-2.6-4.4-2.6s-3.5,1-4.3,2.6"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 45.6,
    cy: 80.7,
    r: 12.4
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 45.6,
    cy: 80.7,
    r: 7.8
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M41.2,83c0.8,1.6,2.5,2.6,4.4,2.6s3.5-1.1,4.3-2.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M49.9,78.4c-0.8-1.6-2.5-2.6-4.4-2.6s-3.5,1-4.3,2.6"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M139.6,39.1l38.8,6.3l-18.5-20.3c-1.9-1.9-4.3-3.4-6.9-4.4c-1.8-0.6-3.8-0.9-5.7-0.9h-12.9v13.5 C134.4,36.2,136.6,38.6,139.6,39.1L139.6,39.1z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 127.2,
    y1: 19.8,
    x2: 14.6,
    y2: 19.8
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 14.6,
    y1: 46.3,
    x2: 65.3,
    y2: 46.3
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 38.8,
    y1: 66.9,
    x2: 0.8,
    y2: 66.9
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 174.5,
    y1: 66.9,
    x2: 52.4,
    y2: 66.9
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "211.4,66.9 209.4,66.9 202.2,66.9 188.9,66.9 "
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 134.5,
    y1: 46.3,
    x2: 142.9,
    y2: 46.3
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 118.8,
    y1: 46.3,
    x2: 127.2,
    y2: 46.3
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "7,66.9 0.8,66.9 0.8,46.3 7,46.3 "
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 10.8,
    y1: 75,
    x2: 30.8,
    y2: 75
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 59.9,
    y1: 75,
    x2: 79.9,
    y2: 75
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 147.3,
    y1: 75,
    x2: 167.3,
    y2: 75
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 196.6,
    y1: 75,
    x2: 205.1,
    y2: 75
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M178.4,45.4l-18.5-20.3c-1.9-1.9-4.3-3.4-6.9-4.4c-1.8-0.6-3.8-0.9-5.7-0.9h-12.9l0.1,5.2h10.3 c4.7,0,9.1,1.9,12.3,5.3l13,13.7L178.4,45.4L178.4,45.4z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M139.6,39.1l38.8,6.3l-18.5-20.3c-1.9-1.9-4.3-3.4-6.9-4.4c-1.8-0.6-3.8-0.9-5.7-0.9h-12.9v13.5 C134.4,36.2,136.6,38.6,139.6,39.1L139.6,39.1z"
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 155.8,
    y1: 22.1,
    x2: 155.8,
    y2: 41.7
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M161.7,83.7H65.2c-1.9,0-3.6-1.4-3.8-3.3c-0.3-2.4-1-4.2-1.5-5.4c-2.3-5.7-7.8-9.7-14.3-9.7s-12.1,4-14.3,9.7 c-0.5,1.2-1,3.1-1.3,5.4c-0.2,1.9-1.9,3.3-3.8,3.3l0,0c-0.2,0-0.5,0-0.8-0.1L3.9,79.4c-1.8-0.4-3.1-1.9-3.1-3.8v-30 c0-0.2,0-0.4,0.1-0.7L7.9,4c0.3-1.9,1.9-3.2,3.8-3.2h117.2c3.8,0,7.6,1,10.9,2.9l0,0c7.9,4.6,15.1,10.3,21.2,17l15.4,16.6 c2.2,2.3,4.8,4.2,7.7,5.5L207,53c1.1,0.5,2,1.6,2.2,2.8l2.4,12.4c0.1,0.2,0.1,0.5,0.1,0.7v9.3c0,1.9-1.4,3.6-3.4,3.8l-7.8,1 c-1.6,0.2-2.9-0.9-3.1-2.5c-0.3-2.3-0.9-4.3-1.4-5.6c-2.3-5.7-7.8-9.7-14.3-9.7s-12.1,4-14.3,9.7c-0.5,1.3-1.3,3.1-1.9,5.8 C165,82.5,163.5,83.7,161.7,83.7L161.7,83.7z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVan);
export default __webpack_public_path__ + "static/media/van.574df6eb1988138c437ed08b056ed0a5.svg";
export { ForwardRef as ReactComponent };